import { generate_guid } from '@/rlMxModules/utils/util'

class rlSlabModelSectData {
    constructor(ID = null, Name = null, Kind = null, Mat = null, Thickness = null, Guid = null) {
        // this.ID = ID  // 数据库ID
        this.Name = Name //截面名称
        this.Kind = Kind;//设置一个默认截面类型提供给检测
        this.Mat = Mat;
        this.Thickness = Thickness;
        this.Guid = Guid ? Guid : generate_guid()
    }
}

export default rlSlabModelSectData
